import { toast } from "react-toastify";
import { COMMON, EXTERNAL_LEADS } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

/** GET `external-leads/metadata` — table columns + filter definitions. */
export const getExternalLeadsMetadata = async () => {
  try {
    const response = await GET(EXTERNAL_LEADS.GET_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `external-leads/filter` — paged external leads list. */
export const submitExternalLeadsFilterData = async (data = {}) => {
  try {
    const response = await POST(EXTERNAL_LEADS.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/external-lead-source` — source filter dropdown options. */
export const fetchExternalLeadSourceOptions = async () => {
  try {
    const response = await GET(COMMON.EXTERNAL_LEAD_SOURCE);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/external-lead-status` — status filter dropdown options. */
export const fetchExternalLeadStatusOptions = async () => {
  try {
    const response = await GET(COMMON.EXTERNAL_LEAD_STATUS);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `external-leads/{id}` — single external lead detail. */
export const getExternalLeadById = async (id = "") => {
  const leadId = String(id ?? "").trim();
  if (!leadId) return null;
  try {
    const response = await GET(`${EXTERNAL_LEADS.GET_BY_ID}/${leadId}`);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
